
/**
 * Initializes a scroll-triggered animation for elements matching a selector.
 *
 * @param {string} selector - The CSS selector for the elements to be animated.
 * @param {string} animationClass - The CSS class to add when an element becomes visible.
 * @param {string} initialClass - The CSS class that defines the initial state of the elements (e.g., hidden).
 * @param {number} [threshold=0.1] - The IntersectionObserver threshold (0.0 to 1.0) for triggering the animation.
 */
function createScrollObserver(selector, animationClass, initialClass, threshold = 0.1) {
    const elements = document.querySelectorAll(selector);

    if (elements.length === 0) {
    // console.warn(`ScrollObserver: No elements found for selector "${selector}"`);
    return;
    }

    const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        entry.target.classList.add(animationClass);
        // Optionally remove the initial state class if it's no longer needed
        // entry.target.classList.remove(initialClass); 
        observerInstance.unobserve(entry.target); // Stop observing the element once animated
        }
    });
    }, { threshold: threshold });

    elements.forEach(element => {
    element.classList.add(initialClass); // Set initial state
    observer.observe(element);
    });
}
window.createScrollObserver = createScrollObserver;

// 预处理文字结构（页面加载时执行）
function prepareAnimatedText(container) {
  const text = container.dataset.text;
  container.innerHTML = '';

  const words = text.split(' ');

  words.forEach((word, wIndex) => {
    const wordSpan = document.createElement('span');
    wordSpan.className = 'word';

    word.split('').forEach((char, cIndex) => {
      const letterSpan = document.createElement('span');
      letterSpan.className = 'letter';
      letterSpan.textContent = char;

      wordSpan.appendChild(letterSpan);
    });

    container.appendChild(wordSpan);
  });
  const letters = container.querySelectorAll('.letter');
  gsap.set(letters, {
    opacity: 0,
    y: 20,
    filter: 'blur(15px)',
    textShadow: '0 0 60px rgba(255, 255, 255, 0.6), 0 0 30px rgba(255, 255, 255, 0.4)',
  });
}

// GSAP动画文本功能（滚动触发时执行）
function animateText(container) {
  const letters = container.querySelectorAll('.letter');

  // 创建GSAP时间线动画
  const tl = gsap.timeline();

  letters.forEach((letter, index) => {
    const delay = index * 0.015;

    tl.to(
      letter,
      {
        opacity: 1,
        y: 0,
        duration: 0.15,
        ease: 'power2.out',
      },
      delay
    )
      .to(
        letter,
        {
          filter: 'blur(7.5px)',
          textShadow: '0 0 30px rgba(255, 255, 255, 0.4), 0 0 10px rgba(255, 255, 255, 0.3)',
          duration: 0.2,
          ease: 'power2.out',
        },
        delay + 0.1
      )
      .to(
        letter,
        {
          filter: 'blur(3.5px)',
          textShadow: '0 0 10px rgba(255, 255, 255, 0.2)',
          duration: 0.2,
          ease: 'power2.out',
        },
        delay + 0.25
      )
      .to(
        letter,
        {
          filter: 'blur(0px)',
          textShadow: 'none',
          duration: 0.15,
          ease: 'power2.out',
        },
        delay + 0.4
      );
  });
}

// 初始化动画文本系统
function initAnimatedText(selector = '.animated-on-scroll') {
  // 页面加载时预处理所有动画文本
  document.querySelectorAll(selector).forEach((el) => {
    prepareAnimatedText(el);
  });

  // 使用GSAP的ScrollTrigger来优化滚动检测
  if (typeof gsap !== 'undefined' && gsap.registerPlugin) {
    gsap.registerPlugin(ScrollTrigger);

    // 为每个动画元素创建ScrollTrigger
    document.querySelectorAll(selector).forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          if (el.dataset.animated !== 'true') {
            el.dataset.animated = 'true';
            animateText(el);
          }
        },
      });
    });
  }
}

window.initAnimatedText = initAnimatedText;


